// extracted by mini-css-extract-plugin
export default {"priceDetailContainer":"PricesDetail_priceDetailContainer__UW5tn","priceDetailInfo":"PricesDetail_priceDetailInfo__bhrrb"};